/* el-favorites.js — favoris client (localStorage), partagé PDP + cartes collection.
   Stocke {handle, title, image, price, url}. Toute page avec des boutons
   [data-el-fav-toggle] est câblée automatiquement au chargement. */
(function () {
  var KEY = 'el_favorites_v1';

  function readAll() {
    try {
      var raw = localStorage.getItem(KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function writeAll(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) { /* stockage plein/refusé : dégradation silencieuse */ }
  }

  function has(handle) {
    return readAll().some(function (f) { return f.handle === handle; });
  }

  function toggle(data) {
    var list = readAll();
    var i = list.findIndex(function (f) { return f.handle === data.handle; });
    var nowActive;
    if (i >= 0) {
      list.splice(i, 1);
      nowActive = false;
    } else {
      list.push(data);
      nowActive = true;
    }
    writeAll(list);
    syncButtons();
    syncBubble();
    document.dispatchEvent(new CustomEvent('el:favorites-changed', { detail: { list: list } }));
    return nowActive;
  }

  function syncButtons() {
    var list = readAll();
    var handles = {};
    list.forEach(function (f) { handles[f.handle] = true; });
    document.querySelectorAll('[data-el-fav-toggle]').forEach(function (btn) {
      var h = btn.getAttribute('data-el-fav-handle');
      var active = !!handles[h];
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function syncBubble() {
    var n = readAll().length;
    document.querySelectorAll('[data-el-fav-count]').forEach(function (el) {
      el.textContent = n;
      el.closest('[data-el-fav-bubble-wrap]') && el.closest('[data-el-fav-bubble-wrap]').classList.toggle('is-empty', n === 0);
    });
  }

  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest ? evt.target.closest('[data-el-fav-toggle]') : null;
    if (!btn) return;
    evt.preventDefault();
    toggle({
      handle: btn.getAttribute('data-el-fav-handle') || '',
      title: btn.getAttribute('data-el-fav-title') || '',
      image: btn.getAttribute('data-el-fav-image') || '',
      price: btn.getAttribute('data-el-fav-price') || '',
      url: btn.getAttribute('data-el-fav-url') || '#',
    });
  });

  // Synchro multi-onglets (ajout depuis un onglet, reflet immédiat dans un autre)
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) { syncButtons(); syncBubble(); }
  });

  window.ElFavorites = { all: readAll, has: has, toggle: toggle };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { syncButtons(); syncBubble(); });
  } else {
    syncButtons();
    syncBubble();
  }
})();
